"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFrameWrapper = void 0;
var iFrameStyle = "position: fixed; top: 0; left: 0; z-index: 6001; width: 100%; height: 100%; border: 0; background: rgba(255, 255, 255, 0.8);";
var IFrameWrapper = /** @class */ (function () {
    function IFrameWrapper(url, title, appendTo) {
        var iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.id = 'userFeedback';
        iframe.title = title;
        iframe.setAttribute('style', iFrameStyle);
        iframe.style.display = 'none';
        appendTo.appendChild(iframe);
        this.iframe = iframe;
    }
    IFrameWrapper.prototype.show = function () {
        this.iframe.style.display = 'block';
        var contentWindow = this.iframe.contentWindow;
        if (contentWindow && contentWindow.focus) {
            contentWindow.focus();
        }
    };
    IFrameWrapper.prototype.hide = function () {
        this.iframe.style.display = 'none';
    };
    IFrameWrapper.prototype.destroy = function () {
        var parentNode = this.iframe.parentNode;
        if (parentNode) {
            parentNode.removeChild(this.iframe);
        }
    };
    Object.defineProperty(IFrameWrapper.prototype, "wrappedIFrame", {
        get: function () {
            return this.iframe;
        },
        enumerable: false,
        configurable: true
    });
    return IFrameWrapper;
}());
exports.IFrameWrapper = IFrameWrapper;
//# sourceMappingURL=iframe.js.map